import ko from 'knockout';
import _ from 'underscore';
import { BaseLocationRecommendationModel } from './base-location-recommendation-model';

export default class Model extends BaseLocationRecommendationModel {
  constructor({
    i18n,
    scope,
    isExpanded,
  }) {
    super({
      deps: {
        i18n,
      },
    });
    this.campaignLength = ko.computed(() => _.chain(this.locationRecommendations())
      .pluck('Campaign')
      .pluck('Id')
      .uniq()
      .size()
      .value());
    this.description = ko.computed(() => i18n.getString('Inline_Location_Recommendation_Description', {
      trafficGain: this.locationTrafficGain(),
      impressionGain: this.locationImpressionGain(),
    }));
    this.selectedItems = ko.observableArray([]);
    this.isActionButtonEnabled = ko.computed(() => this.selectedItems().length > 0);
    this.banner = ko.computed(() => {
      let key = 'Inline_Location_Recommendation_Account_Banner';
      if (_.isFinite(scope.campaignId)) {
        key = 'Inline_Location_Recommendation_Campaign_Banner';
      }
      return i18n.getString(key, {
        recommendationCount: _.size(this.locationRecommendations()),
        trafficGain: this.locationTrafficGain(),
        impressionGain: this.locationImpressionGain(),
        campaignNumber: this.campaignLength(),
      });
    });
    this.hasRecommendation = ko.computed(() => _.size(this.locationRecommendations()) > 0);
    this.isExpanded = ko.observable(isExpanded);
    this.clickCollapse = () => {
      this.isExpanded(!this.isExpanded());
    };
    this.criterions = ko.observableArray([]);
    this.recommendationsOnMap = ko.observableArray([]);
    this.isMapShow = ko.computed(() =>
      _.size(this.criterions()) > 0 || _.size(this.recommendationsOnMap()) > 0);
    this.showLocationsRecommendationsGrid = ko.computed(() =>
      this.hasRecommendation() || this.isMapShow());
  }
}
